"use strict";

angular.module("licensure.services").factory("EXType", [
    "$http",
    "$q",
    function($http, $q) {
        return {
            get: function() {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamTypes", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            getfilter: function () {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamTypesFilter", {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            gettype: function(id) {
                var d = $q.defer();

                $http
                    .get(apiLocation + "/api/ExamModule/ExamTypes/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        console.log(response.data);
                        // handle error
                    });

                return d.promise;
            },

            save: function (examType) {

                var d = $q.defer();

                var method = "POST";
                var url = apiLocation + "/api/ExamModule/ExamTypes/";

                if (!isUndefined(examType.id)) {
                    method = "PUT";
                    url += examType.id;
                }

                $http({
                    method: method,
                    url: url,
                    data: examType
                })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

            delete: function(id) {
                var d = $q.defer();

                $http
                    .delete(apiLocation + "/api/ExamModule/ExamTypes/" + id, {
                        params: {}
                    })
                    .then(function (response) {
                        d.resolve(response.data);
                    })
                    .catch(function (response) {
                        // handle error
                    });

                return d.promise;
            },

        };
    }
]);
